import { Stack, Typography } from "@mui/material";
import DataSubmissionStatusTag from "@entrilia/shared/components/dataCollection/DataSubmissionStatusTag";
import { convertISODate, convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import type { DataCollectionSubmissionDetails } from "../../../../../api/types/dataCollectionTypes";

interface Props {
  dataSubmission: DataCollectionSubmissionDetails;
}

const DataSubmissionPageTitle = ({ dataSubmission }: Props) => {
  return (
    <Stack spacing={0.5} sx={{ py: 1.5 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="h6" noWrap>
          {dataSubmission.requestTemplateName}
        </Typography>
        <Typography variant="h6">&bull;</Typography>
        <Typography variant="h6" noWrap>
          {dataSubmission.recipientName}
        </Typography>
        <DataSubmissionStatusTag status={dataSubmission.status} />
      </Stack>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <Typography variant="caption" color="textSecondary">
          Data Submission
        </Typography>

        <Typography variant="caption">&bull;</Typography>
        <Typography variant="caption" color="textSecondary">
          Due Date:
        </Typography>
        <Typography variant="caption">{convertISODate(dataSubmission.dueDate)}</Typography>

        {dataSubmission.status === "Scheduled" && dataSubmission.scheduledToBePublishedAt && (
          <>
            <Typography variant="caption">&bull;</Typography>
            <Typography variant="caption" color="textSecondary">
              Will be published at:
            </Typography>
            <Typography variant="caption">{convertISODateTime(dataSubmission.scheduledToBePublishedAt)}</Typography>
          </>
        )}
      </Stack>
    </Stack>
  );
};

export default DataSubmissionPageTitle;
